module.exports = __webpack_public_path__ + "static/media/2XL.3814cbe1.jpg";